export interface ChargeWaiverRegistrationEntity {

    id: number,
    waiverReasonCode?: string | null,
    chargeType?: string | null,
    subChargeType?: string | null,
    chargeDescription?: string | null,
    activeInd?: string | null,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_CHARGE_WAIVER_REGISTRATION_ENTITY: ChargeWaiverRegistrationEntity = {
    id: 0,
    waiverReasonCode: null,
    chargeType: null,
    subChargeType: null,
    chargeDescription: null,
    activeInd: 'Y',
}
